// extracted by mini-css-extract-plugin
export var article = "article-module--article--EvJLg";